import React from 'react'
import { Box, Center, Heading, Text, VStack } from '@chakra-ui/react'

interface ChartPanelProps {
  symbol: string
}

const ChartPanel: React.FC<ChartPanelProps> = ({ symbol }) => {
  return (
    <>
      <Heading as="h3" fontSize="xl" mb={4}>
        Price Chart
      </Heading>
      
      <Box
        bg="gray.800"
        borderRadius="md"
        height="500px"
        mb={4}
        width="100%"
        overflow="hidden"
        border="1px solid"
        borderColor="gray.700"
      >
        <Center height="100%">
          <VStack spacing={4}>
            <Heading as="h3" color="white" size="md">
              {symbol} Chart
            </Heading>
            <Text color="gray.300">
              Price chart for {symbol} will be displayed here
            </Text>
            <Text fontSize="sm" color="gray.500">
              Historical price data and interactive chart coming soon
            </Text>
          </VStack>
        </Center>
      </Box>
    </>
  )
}

export default ChartPanel
